// Configuração centralizada da API
// Em desenvolvimento: usa localhost
// Em produção: usa o domínio de produção
const configuredApiUrl = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://easy-backend.guiameu.com.br/api' 
    : 'http://localhost:3992/api');

const API_URL = configuredApiUrl
  .replace(/^https?:\/\/easy-backend-node\.athixdev\.xyz\/api\/?$/i, 'https://easy-backend.guiameu.com.br/api')
  .replace(/^https?:\/\/easy-backend-node\.athixdev\.xyz\/?/i, 'https://easy-backend.guiameu.com.br/');

console.log('🔍 Configuração API carregada:', {
  API_URL,
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_API_URL: process.env.REACT_APP_API_URL
});

export default API_URL;
